import { TShortStorageItemSummary } from './storageTypes';

export interface IArticle {
  title: string;
  image_url: string;
  published_at: string;
  description: string;
  redirect_url: string;
  is_stickied: boolean;
  path: string;
  tags: string[];
  participants: any[];
  author: {
    name: string;
  };
  hearts?: number;
  url?: string;
  image?: TShortStorageItemSummary | null;
}

export const enum SpecialTags {
  WeeklyRoute = 'weekly-route',
  PlayLikeThePros = 'play-like-the-pros'
}
